/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Input from '@cashew/input';
import Button from '@cashew/button';
import { useEnterListener } from '@cashew/hooks';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import './index.css';
import ExportModal from './ExportModal';
import {
  getFormattedDispatchStatus,
  processDispatchStatus,
} from './dispatch.functions';
import SelectComponent from '../../components/SelectComponent';

const { api } = require('@cashew/utils');

const statusFilterData = [
  {
    key: 'ALL',
    value: 'All',
  },
  {
    key: 'DISPATCHED',
    value: 'Dispatched',
  },
  {
    key: 'NOT_SHIPPED',
    value: 'Not dispatched',
  },
  {
    key: 'PENDING_RENEWAL',
    value: 'Pending renewal',
  },
];
export default ({
  setLoading,
  useSelector,
  setRecords,
  setList,
  pageSize,
  pageNumber,
  dispatch,
  setPageNumber,
  history,
  records,
}: any) => {
  const { t } = useTranslation();
  const { token, selectedStore } = useSelector((state: any) => state.user);
  const [searchId, setSearchId] = useState('');
  const [searchBy, setSearchBy] = useState<string>('orderId');
  const [dateFrom, setDateFrom] = useState(
    moment().subtract(2, 'years').format('YYYY-MM-DD')
  );
  const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
  const [filterStatus, setFilterStatus] = useState('ALL');
  const [dateToError, setDateToError] = useState('');
  const [dateFromError, setDateFromError] = useState('');

  const [filterParams, setFilterParams] = useState({});
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [enterBtn, setEnterBtn] = useState(false);

  const numericInput = /^[0-9]+$/;

  const searchByData = [
    {
      key: 'orderId',
      value: 'Order ID',
    },
    {
      key: 'reference',
      value: 'Merchant order code',
    },
    {
      key: 'phoneNumber',
      value: 'Phone number',
    },
    {
      key: 'email',
      value: 'Email',
    },
    {
      key: 'nationalId',
      value: 'National ID',
    },
  ];

  const getOrdersApi = (resetPageNumber = true) => {
    if (resetPageNumber && pageNumber !== 0) {
      setPageNumber(0);
      return;
    }
    setLoading(true);

    const params: any = {
      page: pageNumber,
      size: pageSize,
      storeId: selectedStore > 0 ? selectedStore : null,
      dateFrom,
      dateTo,
      ...processDispatchStatus({ status: filterStatus }),
    };
    if (searchId && searchBy) {
      params[searchBy] = searchId;
    }
    setFilterParams(params);
    api
      .get({
        endpoint: 'orders',
        params,
        headers: {
          Authorization: token,
        },
      })
      .then((resp: any) => {
        setRecords(resp.totalCount);
        setLoading(false);
        const data = resp.data.map((item: any) => {
          const newItem = item;
          newItem.status = getFormattedDispatchStatus({ item });
          newItem.date = item.purchaseDate;
          newItem.merchantOrderCode = item.sharafdgRef || item.orderReference;
          newItem.goTo =
            item.productType === 'SUBSCRIPTION'
              ? 'subscriptions'
              : 'dispatches';
          return newItem;
        });
        setList(data);
      })
      .catch(() =>
        dispatch({
          type: 'OPEN_TOASTER',
          payload: {
            toasterTitle: t('dispatches.error.fetchingList.title'),
            toasterMessage: t('dispatches.error.fetchingList.message'),
            toasterType: 'error',
            toasterVisible: true,
            toasterDismiss: null,
          },
        })
      );
  };

  useEnterListener(() => setEnterBtn((prev) => !prev));

  useEffect(() => {
    setSearchId('');
  }, [searchBy]);

  useEffect(() => {
    getOrdersApi(false);
  }, [
    filterStatus,
    selectedStore,
    dateFrom,
    dateTo,
    pageNumber,
    pageSize,
    enterBtn,
  ]);

  const getExcelReport = () => {
    api
      .get({
        endpoint: 'orders/excel',
        responseType: 'blob',
        params: { ...filterParams, dispatches: true },
        headers: {
          Authorization: token,
        },
      })
      .then((response: any) => {
        const [firstDate, secondDate] = new Date()
          .toLocaleString('no-nb')
          .split(',');
        const name = [
          ...firstDate.split('/'),
          ...secondDate.trim().split(':'),
        ].join('-');
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        const blob = response;
        const a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `Dispatches_report_${name}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const handleSelectChange = (selectedKey: string) => {
    setSearchId('');
    setSearchBy(selectedKey);
  };

  return (
    <>
      <div className="filters">
        <div className="filters-wrapper">
          <div className="filters">
            <div className="filter-group">
              <div className="filter-input">
                <SelectComponent
                  label="Search by"
                  data={searchByData}
                  selected={searchBy}
                  onSelect={handleSelectChange}
                />
              </div>
              <div className="filter-input">
                <Input
                  name="orderId"
                  value={searchId}
                  maxLength={searchBy === 'orderId' ? 14 : 100}
                  type="text"
                  onChange={(e: any) => {
                    const searchValue = e.target.value.trim();
                    if (searchBy === 'orderId') {
                      if (
                        searchValue.match(numericInput) ||
                        searchValue === ''
                      ) {
                        setSearchId(searchValue);
                      }
                    } else {
                      setSearchId(searchValue);
                    }
                  }}
                />
              </div>
              <div className="filter-input">
                <button
                  type="button"
                  className="btn blue"
                  onClick={() => {
                    getOrdersApi();
                  }}
                >
                  Search
                </button>
              </div>
            </div>
            <div className="filter-group">
              <div className="filter-input">
                <label>From</label>
                <Input
                  name="dateFrom"
                  value={dateFrom}
                  error={dateFromError ? ' ' : ''}
                  type="date"
                  onChange={(e: any) => {
                    setDateToError('');
                    setDateFrom(
                      moment(e.currentTarget.value).format('YYYY-MM-DD')
                    );

                    if (
                      moment(e.currentTarget.value).isAfter(dateTo) &&
                      dateTo
                    ) {
                      setDateFromError(t('validation-less'));
                    } else {
                      setDateFromError('');
                    }
                  }}
                />
                <span className="error-message">{dateFromError}</span>
              </div>

              <div className="filter-input">
                <span>To</span>
                <Input
                  name="dateTo"
                  error={dateToError ? ' ' : ''}
                  value={dateTo}
                  type="date"
                  onChange={(e: any) => {
                    setDateFromError('');
                    setDateTo(
                      moment(e.currentTarget.value).format('YYYY-MM-DD')
                    );
                    if (
                      moment(e.currentTarget.value).isBefore(dateFrom) &&
                      dateFrom
                    ) {
                      setDateToError(t('validation-greater'));
                    } else {
                      setDateToError('');
                    }
                  }}
                />
                <span className="error-message">{dateToError}</span>
              </div>
            </div>
            <div className="filter-group">
              <div className="filter-input">
                <SelectComponent
                  label="Status"
                  data={statusFilterData}
                  selected={filterStatus}
                  onSelect={setFilterStatus}
                />
              </div>

              <div className="filter-input">
                <Button
                  extraClass={records ? 'btn blue' : ''}
                  disabled={!records}
                  onClick={() => setShowCancelModal(true)}
                >
                  Export to Excel
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ExportModal
        showConfirmModal={showCancelModal}
        setShowConfirmModal={setShowCancelModal}
        token={token}
        history={history}
        dispatch={dispatch}
        getExcelReport={getExcelReport}
        records={records}
      />
    </>
  );
};
